import { CALL_API } from "constants/api";
import { Catalog as CatalogSchema } from "schemas/catalogs";
import CatalogRecord from "records/catalog";
import { mutateAsync } from "lib/api";
import { createQuery, updateQuery } from "queries/catalog";
import { add as snackbarAdd } from "actions/snackbars";
import Globalize from "globalize";
import {
    CATALOG,
    CATALOG_FAILURE,
    CATALOG_REQUEST,
    CATALOG_SUCCESS,
    CATALOG_UPDATE,
    CATALOG_RESET,
    CATALOG_ENTRIES_REFRESH,
} from "constants/action-types";
import _ from "lodash";

export const fetchCatalog = (id, meta) => {
    return (dispatch, getState) => {
        const { viewAs } = getState().scope;

        const query = {
            __meta: true,
            __fields: "__all",
            __company: viewAs && viewAs._id,
        };

        dispatch({
            [CALL_API]: {
                types: [CATALOG_REQUEST, CATALOG_SUCCESS, CATALOG_FAILURE],
                endpoint: `/api/v3.1/catalog/${id}`,
                schema: CatalogSchema,
                records: {
                    catalogs: CatalogRecord,
                },
                query,
                meta,
            },
        });
    };
};

export const createLinesheet = (params) => {
    return (dispatch) => {
        dispatch({
            type: CATALOG_REQUEST,
        });
        dispatch(mutateAsync(createQuery(params))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                const catalogRecord = new CatalogRecord(data.body);

                // Catalog reducer doesn't work the way other ones do, entities are nested inside
                dispatch({
                    type: CATALOG_SUCCESS,
                    data: {
                        entities: {
                            catalogs: {
                                [data.transformed._result]: catalogRecord,
                            },
                        },
                        result: [data.transformed._result],
                    },
                });
            } else if (status === 403) {
                dispatch({
                    type: CATALOG_FAILURE,
                });
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("You do not have permission to create a linesheet"),
                    })
                );
            } else {
                dispatch({
                    type: CATALOG_FAILURE,
                });
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    })
                );
            }
        });
    };
};

export const updateCatalog = (id, params) => {
    return (dispatch) => {
        dispatch({
            type: CATALOG_UPDATE,
        });
        dispatch(mutateAsync(updateQuery(id, params))).then((data) => {
            const { status } = data;
            if (status >= 200 && status < 300) {
                const catalogRecord = new CatalogRecord(data.body);

                // Catalog reducer doesn't work the way other ones do, entities are nested inside
                dispatch({
                    type: CATALOG_SUCCESS,
                    data: {
                        entities: {
                            catalogs: {
                                [data.transformed._result]: catalogRecord,
                            },
                        },
                        result: [data.transformed._result],
                    },
                });
            } else if (status === 400) {
                // Bad args, likely trying to clear title, which is a noop
            } else if (status === 403) {
                dispatch({
                    type: CATALOG_FAILURE,
                });
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("You do not have permission to modify linesheets"),
                    })
                );
            } else {
                dispatch({
                    type: CATALOG_FAILURE,
                });
                dispatch(
                    snackbarAdd({
                        message: Globalize.formatMessage("Oops! Something went wrong. Please refresh and try again."),
                    })
                );
            }
        });
    };
};

export const forceRefreshEntries = (forceRefresh) => ({ type: CATALOG_ENTRIES_REFRESH, payload: { forceRefresh } });

export const reset = () => ({ type: CATALOG_RESET });

export const importCatalog = (results, catalogId) => {
    const body = new FormData();
    const resultsWithoutFiles = [];
    results.forEach((result) => {
        body.append("file", result.file);
        resultsWithoutFiles.push(_.omit(result, "file"));
    });
    body.append("filesData", JSON.stringify(resultsWithoutFiles));
    if (catalogId) {
        body.append("catalogId", catalogId);
    }

    return {
        type: CATALOG.IMPORT.START,
        payload: { url: "/api/v3.0/vetl/linesheet/import", body },
    };
};

export const resetImportCatalogState = () => ({ type: CATALOG.IMPORT.RESET_STATE });

export const setCatalogProcessing = (catalogId, processing) => ({
    type: CATALOG.SET_PROCESSING,
    payload: { catalogId, processing },
});
